import { TCGValueProps } from "./value-props.component.js";
customElements.define("tcg-value-props", TCGValueProps);
export {
  TCGValueProps
};
//# sourceMappingURL=value-props.js.map
